<template>
  <section>
    <MainLayout>
      <div class="container">
        <div class="box">
          <form>
            <!-- Filters -->
            <b-form-row>
              <b-form-group class="col-md-3" label="Criterio de fechas">
                <b-form-select 
                  size="sm" 
                  v-model="filters.dateCriteria" 
                  :options="optionsCriteriaDates">
                </b-form-select>
              </b-form-group>

              <b-form-group class="col-md-3" label="Fecha desde *" >
                <b-form-datepicker 
                  locale="es" 
                  :class="{'active-filter':filters.startDate}" 
                  reset-button size="sm" 
                  v-model="filters.startDate"/>
              </b-form-group>

              <b-form-group class="col-md-3" label="Hasta *" >
                <b-form-datepicker 
                  locale="es" 
                  :class="{'active-filter':filters.endDate}" 
                  reset-button  
                  size="sm" 
                  v-model="filters.endDate"/>
              </b-form-group>

              <b-form-group class="col-lg-1" label="Viaje">
                <b-form-select
                  :class="{ 'active-filter': filters.trip }"
                  v-model="filters.trip"
                  :options="tripOpts"/>
              </b-form-group>

              <b-form-group class="col-md-2 table-responsive">
                <br>
                <b-button 
                  variant="outline-primary" 
                  type="button" 
                  @click="checkform()">
                  <md-icon icon="search"/>
                </b-button>
              </b-form-group>

            </b-form-row>

            <b-form-row>
              <b-form-group class="col-md-2" label="Criterio de Agrupación">
                <b-form-select 
                  size="sm" 
                  v-model="filters.group" 
                  :options="optionsGroup">
                </b-form-select>
              </b-form-group>

              <b-form-group class="col-md-3" label="Agrupar por">
                <b-form-radio-group
                  id="btn-radios-1"
                  v-model="filters.timeGroup"
                  :options="optionsTimeGroup"
                  buttons
                  name="radios-btn-default">
                </b-form-radio-group>
              </b-form-group>

              <b-form-group class="col-lg-3 mt-0" label="Calificación">
                <multiselect
                  v-model="filters.stars"
                  :options="starsOpts"
                  group-label="group"
                  group-values="options"
                  group-select
                  multiple
                  label="text"
                  track-by="value"
                  placeholder="Todos"
                  taggable>
                  <template v-slot:clear >
                    <div class="multiselect__clear" @click="filters.stars = []">
                    </div>
                  </template>
                </multiselect>
              </b-form-group>

              <b-form-group class="col-lg-3" label="Zonas">
                <multiselect 
                  v-model="filters.zones"
                  :options="optionsDestinations"
                  group-label="group"
                  group-values="options"
                  group-select
                  multiple
                  label="text"
                  track-by="value"
                  placeholder="Todos"
                  taggable>
                    <span slot="noResult">Oops! No se encontraron resultados.</span>
                    <template v-slot:clear >
                      <div class="multiselect__clear" @click="filters.zones = []"></div>
                    </template>
                </multiselect>
              </b-form-group>

            </b-form-row>
            <!-- End filters -->
          </form>

          <b-row>

            <!-- Loading -->
            <div v-if="loading" class="col-12 text-center pt-5">
              <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
              <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
              <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
            </div>
            <!-- End Loading -->

            <b-col class="col-lg-7 mt-4" v-if="!loading">
              <!-- Show table -->
              <div class="table-responsive async-tables text-center" v-if="showHtmlTable">
                <b-table
                  id="spit-main-table"
                  show-empty
                  hover
                  small
                  bordered
                  stacked-sm
                  responsive
                  :items="table.body" 
                  :fields="table.header"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  selectable
                  select-mode="multi"
                  @row-clicked="item=>onRowSelected(item)">

                  <!-- A virtual column -->
                  <template #cell(index)="data">
                    <div class="text-left">
                      <md-icon 
                        icon="star"
                        class="text-warning font-weight-bolder"
                        style="font-size: 12px; padding-bottom: 2px;"
                        v-if="data.item.star == true"/>
                        {{ data.item.index }}
                        <template v-if="data.rowSelected">
                          <md-icon 
                          icon="keyboard_arrow_down"
                          class="font-weight-bolder"/>
                        </template>
                        <template v-else>
                          <md-icon 
                          icon="keyboard_arrow_right"
                          class="font-weight-bolder"/>
                        </template>
                    </div>
                  </template>

                  <!-- A virtual column -->
                  <template #cell(reviews)="data">
                    <div class="text-right">
                      {{ number_format(data.item.reviews,0,'.',',') }}
                    </div>
                  </template>

                  <!-- A virtual column -->
                  <template #cell(average)="data">
                    <div class="text-right">
                      {{ number_format(data.item.average, 1) }}
                      <md-icon 
                        icon="star"
                        class="text-warning font-weight-bolder"
                        style="font-size: 12px; padding-bottom: 2px;"/>
                    </div>
                  </template>
                  
                  <!-- Row details -->
                  <template #row-details="row">
                    <div class="ml-2">
                      <TableDeep :ref="'table'+row.item.index" @show-details="loadDetails($event)">
                      </TableDeep>
                    </div>
                  </template>

                </b-table>
              </div>
              <!-- End show table -->
            </b-col>
            <b-col class="col-lg-5 mt-4" v-if="!loading">
              <!-- Review Card -->
              <ReviewCard :details="details"></ReviewCard>
              <!-- End Review Card -->
            </b-col>
          </b-row>
        </div>
      </div>
    </MainLayout>
  </section>
</template>
<script>

  import MainLayout from '../../layout/MainLayout.vue'
  import moment from 'moment'
  import Multiselect from 'vue-multiselect'
  import helpers from '../helpers/Reports.js'
  import ReviewCard from './ReviewCard.vue'
  import TableDeep from './Table.vue';

  export default {
    name: "Index",
    components: {MainLayout, Multiselect, ReviewCard, TableDeep},
		mixins: [helpers],
    data() {

      let start = moment().startOf('month').format("YYYY-MM-DD");
      let end   = moment().format("YYYY-MM-DD");

      return {
        loading: false,
        showHtmlTable: true,
        codeReport: 'reviews',
        sortBy: 'index',
        sortDesc: true,
        table: {
          header: [
            {
              key: 'index',
              label: 'Periodo',
              sortable: true
            },
            {
              key: 'reviews',
              label: 'Reseñas',
              sortable: true
            },
            {
              key: 'average',
              label: 'Score',
              sortable: true,
              variant: 'info'
            }
          ],
          body: []
        },
        filters: {
          dateCriteria: 'service-date',
          startDate: start,
          endDate: end,
          timeGroup: 'per-day',
          zones: [],
          trip: 0,
          group: 'destinations',
          parent: null,
          row_selected: null,
          stars: []
        },
        optionsGroup:[
          /*{ text: 'Cuenta', value: 'accounts' },*/
          { text: 'Destino', value: 'destinations' }
        ],
        optionsCriteriaDates:[
          { text: 'Por fecha de servicio', value: 'service-date'},
          { text: 'Por fecha de reseña',   value: 'review-date' },
        ],
        optionsTimeGroup:[
          { text: 'Año',    value: 'per-year' },
          { text: 'Mes',    value: 'per-month' },
          { text: 'Semana', value: 'per-week' },
          { text: 'Dia',    value: 'per-day' },
        ],
        optionsDestinations: [],
        details: {
          title: "",
          stars: [
            {"label": 5, "value" : 0},
            {"label": 4, "value" : 0},
            {"label": 3, "value" : 0},
            {"label": 2, "value" : 0},
            {"label": 1, "value" : 0}
          ],
          max: 0,
          average: 0.0,
          parent: '',
          tags: [],
          comments: [],
          platform: "",
          destination: "",
          supplier: ""
        }
      }
    },
    methods: {
      checkform() {
        let errors = [];
        if (this.filters.startDate === "" || this.filters.endDate === "") {
          errors.push("Fecha inicio y fecha fin son requeridos");
        }

        if (this.filters.dateCriteria === "") {
          errors.push("Criterio fechas es requerido");
        }
        if (errors.length === 0) {
          this.search();
        } else {
          this.$root.showAlert(errors[0],{variant:'warning'});
        }
      },
      search() {
        
        this.loading        = true
        this.showHtmlTable  = false;
        this.table.body     = []
        this.filters.parent = null
        this.filters.row_selected = null;
        this.reloadDetails()

        this.$root.api.get(`/reports/${this.codeReport}`, {
          params: {filters: this.filters}
        }).then((res) => {
          this.showHtmlTable = true;
            const data = res.data.body;

            let body = []
            for (const group in data) {
              body.push(data[group])
            }
            
            this.table.body = body
        }).catch(this.$root.handleRequestError)
        .finally(() => {
          this.loading = false;
        });
      },
      onRowSelected(item) {
        this.$set(item, '_showDetails', !item._showDetails)
        this.$nextTick(() => {
          if (item._showDetails) {
            const childComponent = this.$refs['table'+item.index];
            if (childComponent) {
              this.filters.row_selected = item.index
              this.filters.parent       = item.row_type
              this.filters.period       = item.period
              childComponent.loadTable(this.filters, item.index);
            } else {
              console.error('Table Child component reference is undefined.');
            }  
          }
        })
      },
      loadDetails(data) {

        this.reloadDetails()

        let stars = []
        for (const property in data.item.stars) {
          stars.push({"label": property, "value": data.item.stars[property]})
        }

        this.details.stars       = stars.sort((a,b) => parseInt(b.label) - parseInt(a.label))
        this.details.max         = data.item.reviews
        this.details.title       = data.item.index
        this.details.average     = data.item.average
        this.details.reviews     = data.item.reviews
        this.details.stars_round = data.item.stars_round
        this.details.parent      = data.item.parent_name
        this.details.platform    = data.item.platform
        this.details.supplier    = data.item.supplier
        this.details.destination = data.item.destination

        let tags = []
        Object.keys(data.item.tags).forEach(key => {
          tags.push({"label": key, "value" : data.item.tags[key]})
        });

        this.details.tags = tags

        this.getComments(data.item)
      },
      reloadDetails() {

        this.details.stars = [
          {"label": 5, "value" : 0},
          {"label": 4, "value" : 0},
          {"label": 3, "value" : 0},
          {"label": 2, "value" : 0},
          {"label": 1, "value" : 0}
        ]

        this.details.max         = 0
        this.details.title       = ''
        this.details.average     = 0
        this.details.reviews     = 0
        this.details.stars_round = 0
        this.details.parent      = ''
        this.details.tags        = []
        this.details.comments    = []
      },
      getComments(item) {
        let filters = Object.assign({}, this.filters)
        filters.comments   = true
        filters.parent_row = item.parent_row
        filters.row_type   = item.row_type
        filters.index      = item.index

        this.$root.api.get(`/reports/${this.codeReport}`, {
            params: {
              filters: filters
            }
          })
          .then(res => {
            const data = res.data.body;
            this.details.comments = data;
          }).catch(this.$root.handleRequestError)
          .finally(() => {
            this.loading = false;
          });
      },
      getDestinationsOpts() {
        let destinations = []

        this.$root.api.get(`/reviews/destinations`).then((res) => {
					const data = res.data;
            data.forEach(element => {
              destinations.push({value: element, text: element})
            });

            this.optionsDestinations = [
              {
                group: "SELECT ALL",
                options: destinations
              }
            ]
				}).catch(this.$root.handleRequestError);

      },
      number_format (number, decimals, dec_point, thousands_sep) {
        // Strip all characters but numerical ones.
        number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
        var n = !isFinite(+number) ? 0 : +number,
        prec  = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep   = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec   = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s     = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
        
        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
        if (s[0].length > 3) {
          s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }

        if ((s[1] || '').length < prec) {
          s[1] = s[1] || '';
          s[1] += new Array(prec - s[1].length + 1).join('0');
        }

        return s.join(dec);
      }
    },
    computed: {
      filtersClean(){
				let zonesIds     = this.filters.zones.map((item)=>item.value);
				let supplierIds  = this.filters.supplier.map((item)=>item.value)
				let statusIds    = this.filters.status.map((item)=>item.value)
				let cpFilters    = {...this.filters};

				cpFilters.zones    = zonesIds;
				cpFilters.supplier = supplierIds;
				cpFilters.status   = statusIds;

				return cpFilters;
			},
      tripOpts() {
        let aux = [...this.$root.auxVars.tripOpts];
        aux.unshift({ value: 0, text: "Todos" });
        return aux;
      },
      starsOpts() {
        return [
          {
            group: "SELECT ALL",
            options: [
              {value:1, text: "1 Estrella"},
              {value:2, text: "2 Estrellas"},
              {value:3, text: "3 Estrellas"},
              {value:4, text: "4 Estrellas"},
              {value:5, text: "5 Estrellas"}
            ]
          }
        ]
      }
    },
    mounted() {
      this.getDestinationsOpts()
    },
  }
</script>